import { useMutation } from "@tanstack/react-query";
import { useLoading } from "./LoadingContext";
import { useEffect } from "react";

const useApiMutation = ({ mutationFn, options = {} }) => {
  const { setIsLoading, setProgress } = useLoading();

  // Use useMutation for POST or other mutation requests
  const mutationResult = useMutation({
    mutationFn,
    ...options,
  });
  const { isLoading } = mutationResult;

  return { ...mutationResult, isLoading };
};

export default useApiMutation;
